module.exports = __webpack_public_path__ + "img/btn2@2x.409d966a.webp";